import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DeclineDocumentSvg = function DeclineDocumentSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 25",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M16.98 2.249H4v8.75h1.385V3.644h11.02l4.21 4.243v12.967H13.5v1.395H22V7.309z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M9 8.499h5v-1.5H9zM19 13.499h-7v-1.5h7zM16 18.499h3v-1.5h-3zM2 20.249l3.22-3.22L2 13.81l1.06-1.06 3.22 3.22 3.22-3.22 1.06 1.06-3.219 3.22 3.22 3.22-1.061 1.06-3.22-3.219-3.22 3.22z"
    })]
  });
};
export var DeclineDocument = function DeclineDocument(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: DeclineDocumentSvg
  }));
};